import { IConsentCookie, ICookieConsentTypesResolverPayload } from "../types/shop-cookies";

export async function requestCookieConsent(): Promise<IConsentCookie> {
    return new Promise<IConsentCookie>((resolve, reject) => {
        const payload: ICookieConsentTypesResolverPayload = { resolve, reject };
        shell?.messageBroker.publishTo("ESMKT.CookieBar.CookieConsentTypesResolver", payload);
    });
}
